function StatsCard({ countHeading, count }) {
    return (
        <div className="flex flex-col ">
            <p className="text-textPrimary text-4xl ">{count}</p>
            <p className="text-sm text-textSecondary font-medium ">{countHeading}</p>
        </div>
    );
}

export default StatsCard;
